import { get } from 'lodash';
import { instance } from './api.service';

export const syncQuickbooks = async () => {
  const resp = await instance.get(`/quick/comparecustomers`, { data: {} });
  return get(resp, 'data.data', []);
};
